import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';

import { DeviceHelper, TimeHelper } from '../_helpers';
import { LogsTable } from './LogsTable';
import { Device } from "../_models/Device";
import { Selectors } from "../_reducers/app.reducer";
import { GenericLogsPage } from "../_components/GenericLogsPage";
import { deviceLogsActions } from "../_actions/deviceLogs.actions";

const devicesArray = [Device()];

export function DeviceLogsColumn() {
    //LIBRARIES
    const dispatch = useDispatch();

    //GLOBAL STATE
    const locationUid   = useSelector(Selectors.getSelectedLocationUid);
    const timezone      = useSelector(Selectors.getTimezone);
    let devices         = devicesArray;
    devices             = useSelector(Selectors.getSelectedLocationDevices);

    const logs              = useSelector(Selectors.getDeviceLogs);
    const isRequesting      = useSelector(Selectors.getDeviceLogsIsRequesting);
    const isRequestingFirst = useSelector(Selectors.getDeviceLogsIsRequestingFirst);
    const nextPage          = useSelector(Selectors.getDeviceLogsNextPage);

    const filterType        = useSelector(Selectors.getDeviceLogsFilterType);
    const filterStatus      = useSelector(Selectors.getDeviceLogsFilterTypeStatus);
    const filterUser        = useSelector(Selectors.getDeviceLogsFilterUser);

    const { begin, end }    = useSelector(Selectors.getDeviceLogsDateFilter);

    //LOCAL STATE
    const [selectedDevices, setSelectedDevices] = useState([]);

    //ACTION HANDLERS
    const handleNextPage                    = () => dispatch(deviceLogsActions.getDeviceLogsNextPage(nextPage, isRequesting));
    const handleLogsDateStartChange         = date => dispatch(deviceLogsActions.setFilterDateBegin(date));
    const handleLogsDateEndChange           = date => dispatch(deviceLogsActions.setFilterDateEnd(date));

    //INITIALIZATION
    useEffect(() => {
        if (!timezone)
            return;

        initialize();

        async function initialize() {
            dispatch(deviceLogsActions.setFilterDateBeginEnd(
                TimeHelper.localizedStartOfTodayIsoString(timezone),
                TimeHelper.localizedEndOfTodayIsoString(timezone),
            ));

        }

    }, [dispatch, locationUid, timezone]);

    //STATE UPDATE
    useEffect(() => {
        updateSelectedDevices();

        function updateSelectedDevices() {
            const newSelectedDevices = devices.filter(device => device.selected);

            setSelectedDevices(prevSelectedDevices =>
                DeviceHelper.haveSelectedDevicesChanged(
                    prevSelectedDevices,
                    newSelectedDevices,
                )
                    ? newSelectedDevices
                    : prevSelectedDevices
            );
        }
    }, [devices]);

    useEffect(() => {
        if (!begin || !end)
            return;

        dispatch(deviceLogsActions.getDeviceLogsFirstPage());
    }, [dispatch,
        selectedDevices,
        begin, end,
        filterType, filterUser, filterStatus,
    ]);

    //VIEW
    return (
        <GenericLogsPage
            isThereLogs={logs.length !== 0}
            hideDates

            isRequesting={isRequesting}
            requestingFirst={isRequestingFirst}
            nextPage={nextPage}

            startIsoString={begin}
            endIsoString={end}
            timezone={timezone}

            content={
                <LogsTable
                    devices={devices}
                    logs={logs}
                    isSmall={false}
                    timezone={timezone}
                />
            }

            handleNextPage={handleNextPage}
            handleLogsDateStartChange={handleLogsDateStartChange}
            handleLogsDateEndChange={handleLogsDateEndChange}
        />
    );
}